import {z} from 'zod';
import {CreateRoutePatternRequest} from '../api/generated/index.defs.ts';

export const routePatternSchema = z.object({
  description: z.string(),
  pattern: z.string(),
}) satisfies z.Schema<CreateRoutePatternRequest>;
export type RoutePatternSchema = z.TypeOf<typeof routePatternSchema>;
